import { Children, useState } from 'react';
import Fila from 'components/corporatiu/Fila';
import Enllac from 'components/corporatiu/Enllac/Enllac';
import Icona from 'components/corporatiu/Icona/';
import Imatge from 'components/corporatiu/Imatge';
import styles from './organsgovernmarato.module.scss';
import { Pestanyes, Pestanya } from 'components/corporatiu/Pestanyes/Pestanyes';

const OrgansGovernMarato = ({ texts }) => {
    return (
        <div>
            <Pestanyes estil='marato'>
                <Pestanya titol={texts.tab1} activa={true}>
                    <div className={styles.pestanya} dangerouslySetInnerHTML={{ __html: texts.content1 }}></div>
                </Pestanya>
                <Pestanya titol={texts.tab2}>
                    <div className={styles.pestanya} dangerouslySetInnerHTML={{ __html: texts.content2 }}></div>
                </Pestanya>
                <Pestanya titol={texts.tab3}>
                    <div className={styles.pestanya} dangerouslySetInnerHTML={{ __html: texts.content3 }}></div>
                </Pestanya>
            </Pestanyes>
        </div>
    );
};

export default OrgansGovernMarato;
